// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2OzDr","title":"ClientInsurance_title__1B0-w","itemText":"ClientInsurance_itemText__2Ante"};